import { AnalysisFileType } from "../../../types/analysisFileTypes";
import GenericAnalysisFilesPage from "./GenericAnalysisFilesPage";


export default function UpcomingBonusRewardsAnalysisFilesPage() {
    return <GenericAnalysisFilesPage
        fileType={AnalysisFileType.UpcomingBonusRewardsAnalysisFile}
        title={"analysisPage.upcomingBonusRewards.title"}
    />
}